<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Vínculo - Centro de custo (ConectaSUS)"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        disabled
                        :value="`${model.nome}${model.cnes ? ` - ${model.cnes}` : ''}`"
                        label="Unidade (Cliente)"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-area
                        title="Centro de custo (ConectaSUS)"
                        type="fieldset"
                    >
                        <rkm-row>
                            <rkm-col cols="4">
                                <rkm-form-select
                                    :options="form.conectasusUnidades"
                                    :validations="validations.conectasusUnidade"
                                    @change="loadInfraestruturas"
                                    label="Unidade"
                                    show-default-option
                                    text-field="nomeFantasia"
                                    v-model="model.conectasusUnidadeId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <rkm-form-select
                                    :disabled="!model.conectasusUnidadeId"
                                    :options="form.conectasusInfraestruturas"
                                    :validations="validations.conectasusInfraestrutura"
                                    @change="loadCentrosCusto"
                                    label="Local de atendimento"
                                    show-default-option
                                    text-field="nome"
                                    v-model="model.conectasusInfraestruturaId"
                                    value-field="id"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <rkm-form-select
                                    :disabled="!model.conectasusInfraestruturaId"
                                    :options="form.conectasusCentrosCusto"
                                    :validations="validations.conectasusCentroCusto"
                                    label="Setor"
                                    show-default-option
                                    text-field="setorNome"
                                    v-model="model.conectasusCentroCustoId"
                                    value-field="id"
                                />
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Fechar
            </rkm-button>

            <rkm-button
                color="primary"
                @click="save"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                conectasusUnidade: {required: true},
                conectasusInfraestrutura: {required: true},
                conectasusCentroCusto: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            unidade: this.getConectaSusRepository('webService.almoxarifado.cliente.unidade'),
        }
    },
    data: () => ({
        unidadeId: null,
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(unidadeId) {
            this.unidadeId = unidadeId
            this.form = null
            this.model = null

            this.load()
            this.$refs.RkmModal.show()
        },
        load() {
            this.setLoading()

            this.repositories.unidade.edit(this.unidadeId)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadInfraestruturas() {
            this.form.conectasusInfraestruturas = []
            this.model.conectasusInfraestruturaId = null
            this.form.conectasusCentrosCusto = []
            this.model.conectasusCentroCustoId = null

            if (!this.model.conectasusUnidadeId) return

            this.setLoading()

            this.repositories.unidade.list(this.camelObjectKeysToSnakeRecursive({
                listar: 'infraestruturas',
                unidadeId: this.model.conectasusUnidadeId,
            }))
                .then(response => {
                    this.form.conectasusInfraestruturas = Object.assign(response.data)

                    if (this.form.conectasusInfraestruturas.length === 1){
                        this.model.conectasusInfraestruturaId = this.form.conectasusInfraestruturas[0].id

                        this.loadCentrosCusto()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadCentrosCusto() {
            this.form.conectasusCentrosCusto = []
            this.model.conectasusCentroCustoId = null

            if (!this.model.conectasusInfraestruturaId) return

            this.setLoading()

            this.repositories.unidade.list(this.camelObjectKeysToSnakeRecursive({
                listar: 'centros-custo',
                infraestruturaId: this.model.conectasusInfraestruturaId,
            }))
                .then(response => {
                    this.form.conectasusCentrosCusto = Object.assign(response.data)

                    if (this.form.conectasusCentrosCusto.length === 1){
                        this.model.conectasusCentroCustoId = this.form.conectasusCentrosCusto[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    this.repositories.unidade.update(this.unidadeId, this.camelObjectKeysToSnakeRecursive(this.model))
                        .then(response => {
                            this.showSaveNotification()
                            this.$emit('saved', response)
                            this.$refs.RkmModal.hide()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, repository, stringCase],
}
</script>